import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { DraftManagerService } from '../draft-manager.service';
import { DraftSelectService } from '../draft-select.service';

@Component({
  selector: 'app-nav-window',
  templateUrl: './nav-window.component.html',
  styleUrls: ['./nav-window.component.scss']
})
export class NavWindowComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private draftManagerService: DraftManagerService,
    private draftSelectService: DraftSelectService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.draftManagerService.setDraftType("none");
    this.onClickMouse();
  }

  onClickMouse() {
    if (this.draftManagerService.draftType !== "free") {
      this.draftSelectService.reset();
      this.draftManagerService.setDraftType("free");
      document.getElementById("draftButton").classList.remove("highlight");
      document.getElementById("mouseButton").classList.add("highlight");
      this.draftManagerService.refresh();
    }
  }

  onClickDraft() {
    if (this.draftManagerService.draftType !== "pro") {
      this.draftSelectService.reset();
      this.draftManagerService.setDraftType("pro");
      if (this.draftManagerService.phaseNum !== -1)
        this.draftManagerService.phaseNum -= 1;
      this.draftManagerService.nextPhase();
      document.getElementById("mouseButton").classList.remove("highlight");
      document.getElementById("draftButton").classList.add("highlight");
      document.getElementById("confirmButton").style.display="inline-block";
      this.draftManagerService.refresh();
    }
  }

  onClickPen() {
    this.dataService.getPenWindow().enter();
  }

  onClickReset() {
    this.draftManagerService.reset();
    this.draftSelectService.reset();
    this.draftManagerService.phaseNum = -1;
    if (this.draftManagerService.draftType === "pro") {
      this.draftManagerService.setDraftType("none");
      this.onClickDraft();
    }
  }

}
